import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { addMerchantRequest, addMerchantRequestStatus } from '../../../redux/merchant/merchant.action'
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import CommonInputFloatHalf from "../../../components/input/common-input-float-half/commonInputFloafHalf";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import { cityListRequest, stateListRequest, countryListRequest } from '../../../redux/user/user.action'
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";
import Modal from 'react-bootstrap/Modal';

const AddMerchant = props => {
    const { user, countryListSuccess, countryListError, stateListSuccess, stateListError,
        cityListSuccess, cityListError, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { addMerchantSuccess, addMerchantError, addMerchantReqStatus } = useSelector(state => state.merchant)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [name, setName] = useState('')
    const [contactPersonName, setContactPersonName] = useState('')
    const [contactPersonNumber, setContactPersonNumber] = useState('')
    const [contactPersonEmail, setContactPersonEmail] = useState('')
    const [address, setAddress] = useState('')
    const [taxType, setTaxType] = useState('')
    const [taxTypeValue, setTaxTypeValue] = useState('')
    const [paymentTerms, setPaymentTerms] = useState('')
    const [isActive, setIsActive] = useState(true)
    const [countryDropdown, setCountryDropdown] = useState();
    const [stateDropdown, setStateDropdown] = useState();
    const [cityDropdown, setCityDropdown] = useState();
    const [countryCode, setCountryCode] = useState('')
    const [showSuccessModal, setShowSuccessModal] = useState(false)

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_MERCHANT, true)
            fetchBusinessList()
        }
        dispatch({ type: APP_CONSTANTS.RESET_STATE_CITY })
        setLoading(true)
        dispatch(countryListRequest())
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    const fetchStateList = (countryId) => {
        setLoading(true)
        const data = {
            countryId: countryId
        }
        dispatch(stateListRequest(data))
    }

    const fetchCityList = (countryId, stateId) => {
        setLoading(true)
        const data = {
            countryId: countryId,
            stateId: stateId
        }
        dispatch(cityListRequest(data))
    }

    useEffect(() => {
        if (addMerchantReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            setShowSuccessModal(true)
        } else if (addMerchantReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(addMerchantError.message)
        }
        if (addMerchantReqStatus?.length) {
            dispatch(addMerchantRequestStatus(''))
        }
    }, [addMerchantSuccess, addMerchantError, addMerchantReqStatus])

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.ADD_MERCHANT) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_MERCHANT, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(countryListSuccess)) {
            setLoading(false)
        } else if (!isNull(countryListError)) {
            setLoading(false)
        }
    }, [countryListSuccess, countryListError])

    useEffect(() => {
        if (!isNull(stateListSuccess)) {
            setLoading(false)
        } else if (!isNull(stateListError)) {
            setLoading(false)
        }
    }, [stateListSuccess, stateListError])

    useEffect(() => {
        if (!isNull(cityListSuccess)) {
            setLoading(false)
        } else if (!isNull(cityListError)) {
            setLoading(false)
        }
    }, [cityListSuccess, cityListError])

    const handleCountrySelectChange = e => {
        setCountryDropdown(e);
        setCountryCode(e.iso2)
        setStateDropdown(null)
        setCityDropdown(null)
        fetchStateList(e.iso2)
    }

    const handleSubmitClick = () => {
        if (isEmpty(name)) {
            displayErrorToast('Merchant name cannot be blank')
        } else if (isEmpty(contactPersonName)) {
            displayErrorToast('Contact person name cannot be blank')
        } else if (isEmpty(contactPersonNumber)) {
            displayErrorToast('Contact person number cannot be blank')
        } else if (isEmpty(contactPersonEmail)) {
            displayErrorToast('Contact person email cannot be blank')
        } else if (isLoggedInUserBusiness(user) && isEmpty(selectedBusiness)) {
            displayErrorToast('Business not selected')
        } else if (isLoggedInUserBusiness(user) && isEmpty(selectedLocation)) {
            displayErrorToast('Business location not selected')
        } else if (isEmpty(address)) {
            displayErrorToast('Merchant address cannot be blank')
        } else if (isEmpty(countryDropdown)) {
            displayErrorToast('Address country not selected')
        } else if (isEmpty(stateDropdown)) {
            displayErrorToast('Address state cannot be blank')
        } else if (isEmpty(cityDropdown)) {
            displayErrorToast('Address city cannot be blank')
        } else {
            setLoading(true)
            const data = {
                name: name,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                contactPersonName: contactPersonName,
                contactPersonEmail: contactPersonEmail,
                contactPersonNumber: contactPersonNumber,
                address: address,
                isActive: isActive,
                productCode: APP_CONSTANTS.PRODUCT_NAME,
                country: countryDropdown.name,
                countryCode: countryDropdown.iso2,
                state: stateDropdown.name,
                stateCode: stateDropdown.iso2,
                city: cityDropdown.name
            }
            if (!isEmpty(paymentTerms)) {
                data.paymentTerms = paymentTerms
            }
            if (!isEmpty(taxType) && !isEmpty(taxTypeValue)) {
                data.taxIdType = taxType
                data.taxId = taxTypeValue
            }
            dispatch(addMerchantRequest(data))
        }
    }

    const clearFields = () => {
        setName('')
        setContactPersonName('')
        setContactPersonNumber('')
        setContactPersonEmail('')
        setAddress('')
        setTaxType('')
        setTaxTypeValue('')
        setPaymentTerms('')
        setIsActive(true)
        setShowSuccessModal(false)
    }

    const handleAddNewMerchantClick = () => {
        setShowSuccessModal(false)
        clearFields()
    }

    const handleGoBack = () => {
        navigate(-1, { replace: true });
    };

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='New Merchant' />
                <CommonFormBorder>
                    <SubTextLabel label='Enter details to add new merchant' />
                    <CommonInputFloatFull
                        id='name'
                        onChange={e => setName(e.target.value)}
                        placeholder='Merchant Name'
                        type='text'
                        value={name}
                        isSubtext={true}
                        subText='Ex. Merchant name or Merchant business name' />
                    <FormFieldLabel label='Contact Person Details' />
                    <CommonInputFloatFull
                        id='contactPersonName'
                        onChange={e => setContactPersonName(e.target.value)}
                        placeholder='Name'
                        type='text'
                        value={contactPersonName} />
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            id='contactPersonNumber'
                            onChange={e => setContactPersonNumber(e.target.value)}
                            placeholder='Contact Number'
                            type='text'
                            value={contactPersonNumber} />
                        <CommonInputFloatHalf
                            id='contactPersonEmail'
                            onChange={e => setContactPersonEmail(e.target.value)}
                            placeholder='Contact Email'
                            type='text'
                            value={contactPersonEmail} />
                    </CommonInputRow>
                    {isLoggedInUserBusiness(user) && <div>
                        <FormFieldLabel label='Business Details' />
                        {isLoggedInUserBusiness(user) === true && <div>
                            <FormFieldLabel label='Select Business' />
                            {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                                className='select-full-width-no-border'
                                value={selectedBusiness}
                                getOptionLabel={e => e.businessName}
                                getOptionValue={e => e}
                                options={userBusinessListSuccess.data}
                                placeholder='Select Business'
                                onChange={e => setSelectedBusiness(e)} />}
                            {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                        </div>}
                        {isLoggedInUserBusiness(user) === true && !isEmpty(selectedBusiness) && <div>
                            <FormFieldLabel label='Select Business Location' />
                            {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                                className='select-full-width-no-border'
                                value={selectedLocation}
                                getOptionLabel={e => e.name}
                                getOptionValue={e => e}
                                options={businessLocationListSuccess.data}
                                placeholder='Select Location'
                                onChange={e => setSelectedLocation(e)} />}
                            {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                        </div>}
                    </div>}
                    <CommonInputFloatFull
                        id='address'
                        onChange={e => setAddress(e.target.value)}
                        placeholder='Address'
                        type='text'
                        value={address}
                        isSubtext={true}
                        subText='Street address only' />
                    {countryListSuccess && <Select
                        menuPlacement="auto"
                        className='select-full-width-no-border'
                        value={countryDropdown}
                        getOptionLabel={e => e.name}
                        getOptionValue={e => e}
                        options={countryListSuccess}
                        placeholder='Select Country'
                        onChange={e => {
                            handleCountrySelectChange(e)
                        }} />}
                    <CommonInputRow>
                        {stateListSuccess && <Select
                            menuPlacement="auto"
                            className='select-half-width up-select-margin'
                            value={stateDropdown}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={stateListSuccess}
                            placeholder='Select State'
                            onChange={e => {
                                setStateDropdown(e);
                                setCityDropdown(null)
                                fetchCityList(countryCode, e.iso2)
                            }} />}
                        {cityListSuccess && <Select
                            menuPlacement="auto"
                            className='select-half-width up-select-margin'
                            value={cityDropdown}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={cityListSuccess}
                            placeholder='Select City'
                            onChange={e => {
                                setCityDropdown(e);
                            }} />}
                    </CommonInputRow>
                    <FormFieldLabel label='Additional Details' />
                    <CommonCheckbox
                        id='isActive'
                        label='Is merchant active'
                        value={isActive}
                        onChange={() => {
                            setIsActive(!isActive)
                        }}
                    />
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            id='taxType'
                            onChange={e => setTaxType(e.target.value)}
                            placeholder='Tax ID Type'
                            type='text'
                            value={taxType} />
                        <CommonInputFloatHalf
                            id='taxTypeValue'
                            onChange={e => setTaxTypeValue(e.target.value)}
                            placeholder='Tax ID'
                            type='text'
                            value={taxTypeValue} />
                    </CommonInputRow>
                    <CommonInputFloatFull
                        id='paymentTerms'
                        onChange={e => setPaymentTerms(e.target.value)}
                        placeholder='Payment Terms'
                        type='text'
                        value={paymentTerms}
                        multiline={true}
                        rows={4} />
                    <ButtonRow>
                        <CommonButton label='Submit' onClick={() => { handleSubmitClick() }} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowSuccessModal(false) }}
                show={showSuccessModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Success
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="at-success-modal-container">
                        <div className="at-success-img-container">
                            <img src={require('../../../assets/success_tick.png')} className="img" />
                        </div>
                        <div className="at-success-text">{addMerchantSuccess?.data?.message}</div>
                        <div className="at-next-task-text">Do you want to add another merchant?</div>
                        <div className="at-modal-btn-container">
                            <div className="at-modal-no-btn" onClick={() => { handleGoBack() }}>NO</div>
                            <div className="at-modal-yes-btn" onClick={() => { handleAddNewMerchantClick() }}>YES</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AddMerchant